import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=7541a3a8"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=7541a3a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports